
import { Vue, Component, Prop } from "vue-property-decorator";

import {
    Custom_Request,
    Document_Custom_Request,
    User
} from "@/generated/graphql";
import SearchableDocumentsList from "@/components/documents/SearchableDocumentsList.vue";
  import UploadDocument from "@/components/documents/UploadDocument.vue";
  import CardInfoChip from "@/components/card/CardInfoChip.vue";

@Component({
    components: {
        CardInfoChip,
      SearchableDocumentsList,
      UploadDocument,
    },
})
export default class Uploads extends Vue {
    @Prop({ type: Object, default: undefined }) readonly request!: Custom_Request;

    // variables
    requestDocuments: Document_Custom_Request[] = [];
    loading: Boolean = true;
    currentUser: User = undefined;

    // methods
    created(): void {
        this.currentUser = Vue.prototype.$currentUser;
    }

    get query(): Object {
        return {
            document_custom_requests: {
                custom_request_id: {
                    _eq: this.request?.id,
                },
            },
        };
    }
}
